import { makeStyles, createStyles } from "@mui/styles";
import customColors from "../../styles/coreStyles/ColorPalette";
import customFonts from "../../styles/coreStyles/Fonts";
// import customFonts from "../../styles/coreStyles/Fonts";

const FilterAndSearchStyle = makeStyles(() =>
  createStyles({
    searchBar: {
      display: "flex",
      flexDirection: "column",
    },
    filterAndArrivalDateDropdownBoxes: {
      display: "flex",
      flexDirection: "row",
      padding: "1rem",
      minWidth: "60%",
    },
    filterGrid: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      flexDirection: "row",
      paddingLeft: "0px",
      paddingTop: "0px",
    },
    arrivalDatePicker: {},
    dropdownAndSearch: {
      display: "flex",
      flexDirection: "row",
      padding: "10px",
      margin: "0",
      backgroundColor: customColors.backgroundGrey,
      borderRadius: "8px",
      borderColor: customColors.groupBlue,
      maxWidth: "100%",
      minWidth: "60%",
    },
    searchSelected: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
    },
    commonText: {
      fontSize: "16px",
      color: customColors.groupBlue,
      fontFamily: customFonts.boldFont,
    },
    arrivalDateText: {
      fontSize: "20px",
    },
    searchIconBox: {
      backgroundColor: customColors.white,
      height: "40px",
      width: "100%",
      borderRadius: "8px",
      padding: "0 15px",
      boxShadow: "0px 0px 8px ${customColorPalette.palette.primary.light}",
      display: "flex",
      alignItems: "center",
    },
    input: {
      backgroundColor: "transparent",
      border: 0,
      fontFamily: "DFDS, sans-serif",
      lineHeight: "24px" /* 150% */,
      letterSpacing: "0.444px",
      fontWeight: 500,
      fontSize: "16px",
      width: "100%",
      outline: 0,
    },
    searchIcon: {
      color: customColors.actionLight,
      marginLeft: "5px",
    },
    searchButton: {
      background: customColors.groupBlue,
      marginLeft: "5px",
      marginRight: "-15px",
      height: "40px",
      fontFamily: customFonts.boldFont,
      "&:hover": {
        background: customColors.groupBlue,
      },
    },
  })
);

export default FilterAndSearchStyle;
